// 社会招聘
import React from 'react'
import styles from './index.module.scss'
import defaultSetting from "@/setting"

class MobileHome extends React.Component {
    constructor(props){
        super(props);
        this.state = {}
    }

    componentWillMount() {
        if (defaultSetting.grayscale) {
            document.querySelector('html').classList.add('grayscale');
        }
    }

    componentDidMount() {
        document.querySelector('.footer').style.display = 'none';
    }

    render() {
        return (
            <>
                <main className={styles.mobileSocial}>
                    <div className="home-wrap">
                        <div className="home-icon-item">
                            <div className="item-main" onClick={()=>{
                                this.props.history.push("/mobile/brand?recruitType=2")
                            }}>
                                <div className="item-icon social"></div>
                                <div className="item-txt">社会招聘</div>
                            </div>
                            <div className="item-main" style={{marginLeft: "2.5rem"}} onClick={()=>{
                                this.props.history.push("/mobile/brand?recruitType=1")
                            }}>
                                <div className="item-icon school"></div>
                                <div className="item-txt">校园招聘</div>
                            </div>
                            <div className="item-main" style={{marginLeft: "2.5rem"}} onClick={()=>{
                                window.location.href = `/${defaultSetting.suiteKeyMc}/mc/my`
                            }}>
                                <div className="item-icon center"></div>
                                <div className="item-txt">个人中心</div>
                            </div>
                        </div>
                        <div className="home-icon-item" style={{marginTop: "1.5rem", bottom: "1.5rem"}}>
                        </div>
                    </div>
                </main>
            </>
        );
    }
  }

  export default MobileHome;
